/**
 * @generated SignedSource<<8d0397305455b8f22b9a210e52a5770e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactSearchFieldsEnum = "AddressLine1" | "AddressLine2" | "AddressLine3" | "City" | "Company" | "Country" | "County" | "Created" | "Email" | "Firstname" | "Id" | "Ids" | "JobTitle" | "Lastname" | "Modified" | "Phone" | "PostalCode" | "Properties" | "Region";
export type OrderEnum = "ASC" | "DESC";
export type PostObjectsConnectionDateColumnEnum = "DATE" | "MODIFIED";
export type RelationEnum = "AND" | "OR";
export type RootQueryToContactConnectionWhereArgs = {
  addressLine1?: string | null | undefined;
  addressLine2?: string | null | undefined;
  addressLine3?: string | null | undefined;
  city?: string | null | undefined;
  company?: string | null | undefined;
  country?: string | null | undefined;
  county?: string | null | undefined;
  createdDateQuery?: DateQueryInput | null | undefined;
  email?: string | null | undefined;
  firstname?: string | null | undefined;
  id?: string | null | undefined;
  idIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  idNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  jobTitle?: string | null | undefined;
  lastname?: string | null | undefined;
  modifiedDateQuery?: DateQueryInput | null | undefined;
  order?: OrderEnum | null | undefined;
  orderBy?: ReadonlyArray<ContactSearchFieldsEnum | null | undefined> | null | undefined;
  phone?: string | null | undefined;
  postalCode?: string | null | undefined;
  region?: string | null | undefined;
  search?: string | null | undefined;
  searchFields?: ReadonlyArray<ContactSearchFieldsEnum | null | undefined> | null | undefined;
};
export type DateQueryInput = {
  after?: DateInput | null | undefined;
  before?: DateInput | null | undefined;
  column?: PostObjectsConnectionDateColumnEnum | null | undefined;
  compare?: string | null | undefined;
  day?: number | null | undefined;
  hour?: number | null | undefined;
  inclusive?: boolean | null | undefined;
  minute?: number | null | undefined;
  month?: number | null | undefined;
  relation?: RelationEnum | null | undefined;
  second?: number | null | undefined;
  week?: number | null | undefined;
  year?: number | null | undefined;
};
export type DateInput = {
  day?: number | null | undefined;
  month?: number | null | undefined;
  year?: number | null | undefined;
};
export type Contact_Pagination_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  where?: RootQueryToContactConnectionWhereArgs | null | undefined;
};
export type Contact_Pagination_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Contact_Pagination_Fragment">;
};
export type Contact_Pagination_Query = {
  response: Contact_Pagination_Query$data;
  variables: Contact_Pagination_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Contact_Pagination_Query",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "Contact_Pagination_Fragment"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Contact_Pagination_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RootQueryToContactConnection",
        "kind": "LinkedField",
        "name": "contacts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToContactConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Contact",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "databaseId",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modified",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstname",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastname",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "company",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "country",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ids",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactToFormEntriesConnection",
                    "kind": "LinkedField",
                    "name": "formEntries",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContactToFormEntriesConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormEntry",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "marketingConsent",
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormEntryToFormConnectionEdge",
                                "kind": "LinkedField",
                                "name": "form",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Form",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "title",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "content",
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToContactConnectionPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "where"
        ],
        "handle": "connection",
        "key": "Contact_Pagination_contacts",
        "kind": "LinkedHandle",
        "name": "contacts"
      }
    ]
  },
  "params": {
    "cacheID": "d0679c2ea038f88a46f7fb135af8134c",
    "id": null,
    "metadata": {},
    "name": "Contact_Pagination_Query",
    "operationKind": "query",
    "text": "query Contact_Pagination_Query(\n  $after: String\n  $first: Int\n  $where: RootQueryToContactConnectionWhereArgs\n) {\n  ...Contact_Pagination_Fragment_3sueo6\n}\n\nfragment Contact_Pagination_Fragment_3sueo6 on RootQuery {\n  contacts(after: $after, first: $first, where: $where) {\n    count\n    edges {\n      cursor\n      node {\n        id\n        databaseId\n        created\n        modified\n        email\n        firstname\n        lastname\n        company\n        country\n        ids\n        jobTitle\n        formEntries {\n          edges {\n            node {\n              marketingConsent\n              created\n              form {\n                node {\n                  title\n                  content\n                  id\n                }\n              }\n              id\n            }\n          }\n        }\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9e9fde043dde1c4096f9454b8c062b6e";

export default node;
